import axios from "axios";
export const getReviewerList = async (journalId) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(
      "https://journalapi.rhc.ac.ir/Admin/GetReviewerList",
      {
        journalId: (journalId !== null && journalId !== undefined) ? journalId : null
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    localStorage.setItem("token", response.data.meta.token);
    console.log(response.data.meta.token);

    return response.data;
  } catch (error) {
    console.error("Axios error:", error.response?.data || error.message);
    return null
  }
};

export const createReviewer = async (values) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(
      "https://journalapi.rhc.ac.ir/Admin/CreateReviewer",
      {

        firstName: values.firstName,
        lastName: values.lastName,
        password: values.password,
        email: values.email,
        JournalIds: values.journal,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    localStorage.setItem("token", response.data.meta.token);
    console.log(response.data.meta.token);
    console.log(response.data);

    return response.data;
  } catch (error) {
    console.error("Axios error:", error.response?.data || error.message);
    return null
  }
};

export const deleteReviewer = async (reviewerId) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(
      "https://journalapi.rhc.ac.ir/Admin/deleteReviewer",
      {
        reviewerId: reviewerId

      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    localStorage.setItem("token", response.data.meta.token);
    console.log(response.data.meta.token);
    console.log(response.data);

    return response.data;
  } catch (error) {
    console.error("Axios error:", error.response?.data || error.message);
    return null
  }
};


export const getJournalList = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(
      "https://journalapi.rhc.ac.ir/Admin/GetJournalS",
      {

      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    localStorage.setItem("token", response.data.meta.token);
    console.log(response.data.meta.token);

    return response.data;
  } catch (error) {
    console.error("Axios error:", error.response?.data || error.message);
    return null
  }
};


export const sendToReview = async (articleId, reviewersId, comment) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(
      "https://journalapi.rhc.ac.ir/Admin/SendToReview",
      {
        articleId: articleId,
        reviewerIds: reviewersId,
        //comment: comment
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    localStorage.setItem("token", response.data.meta.token);
    console.log(response.data.meta.token);

    return response.data;
  } catch (error) {
    console.error("Axios error:", error.response?.data || error.message);
    return null
  }
};

export const createJournal = async (formData) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      "https://journalapi.rhc.ac.ir/Admin/CreateJournal",
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      }
    );

    localStorage.setItem("token", response.data.meta.token);
    console.log(response.data.meta.token);

    return response.data;
  } catch (error) {
    console.error("Axios error:", error.response?.data || error.message);
    return null;
  }
};

export const deleteJournal = async (journalId) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      "https://journalapi.rhc.ac.ir/Admin/DeleteJournal",
      {

        journalId: journalId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    localStorage.setItem("token", response.data.meta.token);
    console.log(response.data.meta.token);

    return response.data;
  } catch (error) {
    console.error("Axios error:", error.response?.data || error.message);
    return null;
  }
};


export const editJournal = async (formData) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      "https://journalapi.rhc.ac.ir/Admin/EditJournal",
      formData, 
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      }
    );

    localStorage.setItem("token", response.data.meta.token);
    return response.data;
  } catch (error) {
    console.error("Axios error:", error.response?.data || error.message);
    return null;
  }
};


export const getReviewerDetail = async (reviewerId) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      "https://journalapi.rhc.ac.ir/Admin/GetReviewerDetail",
      {
        reviewerId: reviewerId

      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    localStorage.setItem("token", response.data.meta.token);
    console.log(response.data.meta.token);

    return response.data;
  } catch (error) {
    console.error("Axios error:", error.response?.data || error.message);
    return null;
  }
};

export const updateReviewer = async (reviewerId, values) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      "https://journalapi.rhc.ac.ir/Admin/EditReviewer",
      {
        reviewerId: reviewerId,
        firstName: values.firstName,
        lastName: values.lastName,
        password: values.password,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    localStorage.setItem("token", response.data.meta.token);
    console.log(response.data.meta.token);

    return response.data;
  } catch (error) {
    console.error("Axios error:", error.response?.data || error.message);
    return null;
  }
};

export const getIssuesList = async (journalId, year) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      "https://journalapi.rhc.ac.ir/Admin/GetJournalIssueS",
      {
        journalId: journalId,
        year: year,

      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    localStorage.setItem("token", response.data.meta.token);
    console.log(response.data.meta.token);

    return response.data;
  } catch (error) {
    console.error("Axios error:", error.response?.data || error.message);
    return null;
  }
};


export const getJournalDetails = async (journalId) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      "https://journalapi.rhc.ac.ir/Admin/GetJournalDetail",
      {
        journalId: journalId,
       
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    localStorage.setItem("token", response.data.meta.token);

    return response.data;
  } catch (error) {
    console.error("Axios error:", error.response?.data || error.message);
    return null;
  }
};

